export default __webpack_public_path__ + "static/media/Clan Bound Belt of the Seven Suns.86511dc3.jpg";